import { useNavigate } from "react-router-dom";
import Service1Vector from "../../images/home/service1-vector.png";
import Service2Vector from "../../images/home/service2-vector.png";
import Service3Vector from "../../images/home/service3-vector.png";
import ServicesImage from "../../images/home/services-bg-image.png";
import ServicesHeadingImage from "../../images/home/services-heading-image.png";

function HomeServices() {
  const navigate = useNavigate();

  return (
    <div className="home-services">
      <img src={ServicesImage} className="bg-image" alt="bg" />
      <canvas className="shape1" />
      <canvas className="shape2" />
      <div className="services">
        <div className="service">
          <div className="service1-img" />
          <img src={Service1Vector} alt="bg" />
          <h2>Integrations services</h2>
          <p>
            We handle end-to-end IT and telecom projects — from software
            delivery to hardware integration. Our team combines deep expertise
            with modern tools, ensuring every solution is tested, secure, and
            ready to perform.
          </p>
          <div className="learn">
            <h3>Learn more</h3>
            <div className="arrow-img" />
          </div>
        </div>
        <div className="service">
          <div className="service2-img" />
          <img src={Service2Vector} alt="bg" />
          <h2>Outsourcing managed services</h2>
          <p>
            BrandOne Technologies provides managed services and IT outsourcing,
            from application support to hosting. We deliver across all support
            levels, using proven methods to keep systems running smoothly.
          </p>
          <div className="learn">
            <h3>Learn more</h3>
            <div className="arrow-img" />
          </div>
        </div>
        <div className="service">
          <div className="service3-img" />
          <img src={Service3Vector} alt="bg" />
          <h2>Research and development</h2>
          <p>
            We deliver end-to-end IT and telecom solutions, integrating
            software, hardware, and security systems. Our expert team uses
            advanced methodologies and modern facilities to ensure top-tier
            performance and quality.
          </p>
          <div className="learn">
            <h3>Learn more</h3>
            <div className="arrow-img" />
          </div>
        </div>
      </div>
      <div className="heading">
        <img src={ServicesHeadingImage} alt="bg" />
        <p>Solutions engineered for impact</p>
      </div>
      <div className="services-cta">
        <h1>Specialized services designed for your organization</h1>
        <p>
          From custom software development to end-to-end IT infrastructure, we
          bring deep technical knowledge and industry insight to every project.
          Our team blends innovation with reliability to solve complex business
          challenges—at scale and with speed.
        </p>
        <button onClick={() => navigate("/contact-us")}>
          <p>Contact us</p>
          <div />
        </button>
      </div>
      <div className="services-scroll">
        <div>
          <p>
            EDMS(Electronic Document Management System) & Document Archival
            System.
          </p>
          <p>Management Information System (MIS) for government sector.</p>
          <p>Electronic Revenue Enhancement System (Automation of IGR).</p>
          <p>e-Procurement System and Vendor Pre-qualifications Portals.</p>
          <p>e-Collaboration Solutions and e-Government Portals.</p>
          <p>Automated Asset tracking using RFID technology.</p>
          <p>Payment Solutions and e-Collection of Bills.</p>
          <p>Biometric Time & Attendance System.</p>
          <p>
            EDMS(Electronic Document Management System) & Document Archival
            System.
          </p>
          <p>Management Information System (MIS) for government sector.</p>
          <p>Electronic Revenue Enhancement System (Automation of IGR).</p>
          <p>e-Procurement System and Vendor Pre-qualifications Portals.</p>
          <p>e-Collaboration Solutions and e-Government Portals.</p>
          <p>Automated Asset tracking using RFID technology.</p>
          <p>Payment Solutions and e-Collection of Bills.</p>
          <p>Biometric Time & Attendance System.</p>
          <p>
            EDMS(Electronic Document Management System) & Document Archival
            System.
          </p>
          <p>Management Information System (MIS) for government sector.</p>
          <p>Electronic Revenue Enhancement System (Automation of IGR).</p>
          <p>e-Procurement System and Vendor Pre-qualifications Portals.</p>
          <p>e-Collaboration Solutions and e-Government Portals.</p>
          <p>Automated Asset tracking using RFID technology.</p>
          <p>Payment Solutions and e-Collection of Bills.</p>
          <p>Biometric Time & Attendance System.</p>
          <p>
            EDMS(Electronic Document Management System) & Document Archival
            System.
          </p>
          <p>Management Information System (MIS) for government sector.</p>
          <p>Electronic Revenue Enhancement System (Automation of IGR).</p>
          <p>e-Procurement System and Vendor Pre-qualifications Portals.</p>
          <p>e-Collaboration Solutions and e-Government Portals.</p>
          <p>Automated Asset tracking using RFID technology.</p>
          <p>Payment Solutions and e-Collection of Bills.</p>
          <p>Biometric Time & Attendance System.</p>
        </div>
      </div>
    </div>
  );
}

export default HomeServices;
